export default __webpack_public_path__ + "maps-examples-tracking-mode-960-9f7fc2d78402613ba0ec939b3273fcd9.png";